import type { GraphQLClient } from 'graphql-request';
import type { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type BlogPostFiltersInput = {
  Date?: InputMaybe<DateFilterInput>;
  IntroText?: InputMaybe<StringFilterInput>;
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogPostFiltersInput>;
  not?: InputMaybe<BlogPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogPostInput = {
  Date?: InputMaybe<Scalars['Date']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  IntroText?: InputMaybe<Scalars['String']['input']>;
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  Text?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  brochure?: InputMaybe<Scalars['ID']['input']>;
  logistics_brochure?: InputMaybe<Scalars['ID']['input']>;
  packaging_brochure?: InputMaybe<Scalars['ID']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandsPageInput = {
  hero_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  tiles_tile_packaging?: InputMaybe<ComponentSharedTileInput>;
  tiles_tile_private_label?: InputMaybe<ComponentSharedTileInput>;
  tiles_title?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BrandsProductPageInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  tiles_tile_packaging?: InputMaybe<ComponentSharedTileInput>;
  tiles_tile_private_label?: InputMaybe<ComponentSharedTileInput>;
  tiles_title?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyPageInput = {
  Whoweare_paragraphs?: InputMaybe<Scalars['String']['input']>;
  certificates_awards?: InputMaybe<Scalars['String']['input']>;
  certificates_awards_badges?: InputMaybe<Array<InputMaybe<ComponentSharedImageArrayInput>>>;
  certificates_certificates?: InputMaybe<Scalars['String']['input']>;
  certificates_certificates_badge?: InputMaybe<Array<InputMaybe<ComponentSharedImagesArrayInput>>>;
  energy_description?: InputMaybe<Scalars['String']['input']>;
  energy_title?: InputMaybe<Scalars['String']['input']>;
  environmentsocial_paragraph?: InputMaybe<Scalars['String']['input']>;
  environmentsocial_quote?: InputMaybe<Scalars['String']['input']>;
  environmentsocial_social_title?: InputMaybe<Scalars['String']['input']>;
  environmentsocial_stats?: InputMaybe<Array<InputMaybe<ComponentSharedStatsArrayInput>>>;
  environmentsocial_title?: InputMaybe<Scalars['String']['input']>;
  environmentsocial_video?: InputMaybe<Scalars['ID']['input']>;
  facilities_largeImage?: InputMaybe<Scalars['ID']['input']>;
  facilities_paragraph_1?: InputMaybe<Scalars['String']['input']>;
  facilities_paragraph_2?: InputMaybe<Scalars['String']['input']>;
  facilities_paragraph_3?: InputMaybe<Scalars['String']['input']>;
  facilities_smallImage1?: InputMaybe<Scalars['ID']['input']>;
  facilities_smallImage2?: InputMaybe<Scalars['ID']['input']>;
  facilities_title?: InputMaybe<Scalars['String']['input']>;
  facilities_video?: InputMaybe<Scalars['ID']['input']>;
  hero_introduction_paragraph?: InputMaybe<Scalars['String']['input']>;
  hero_introduction_title?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  history_details?: InputMaybe<Array<InputMaybe<ComponentSharedTextAndDateArrayInput>>>;
  history_title?: InputMaybe<Scalars['String']['input']>;
  history_video?: InputMaybe<Scalars['ID']['input']>;
  icons_iconswithtext?: InputMaybe<Array<InputMaybe<ComponentSharedIconsArrayInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recycling_description?: InputMaybe<Scalars['String']['input']>;
  recycling_title?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  water_description?: InputMaybe<Scalars['String']['input']>;
  water_title?: InputMaybe<Scalars['String']['input']>;
  whoweare_largeImage?: InputMaybe<Scalars['ID']['input']>;
  whoweare_smallImage?: InputMaybe<Scalars['ID']['input']>;
  whoweare_title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentShared3TextFieldsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentShared3TextFieldsFiltersInput>>>;
  not?: InputMaybe<ComponentShared3TextFieldsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentShared3TextFieldsFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentShared3TextFieldsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedCirclesComponentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCirclesComponentFiltersInput>>>;
  not?: InputMaybe<ComponentSharedCirclesComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCirclesComponentFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedCirclesComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedConfiguratorInput = {
  bg_image?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedContactEmailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedContactEmailFiltersInput>>>;
  department_email?: InputMaybe<StringFilterInput>;
  department_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedContactEmailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedContactEmailFiltersInput>>>;
};

export type ComponentSharedContactEmailInput = {
  department_email?: InputMaybe<Scalars['String']['input']>;
  department_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedExtrasImagesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedExtrasImagesFiltersInput>>>;
  not?: InputMaybe<ComponentSharedExtrasImagesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedExtrasImagesFiltersInput>>>;
};

export type ComponentSharedExtrasImagesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedIconsArrayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedIconsArrayFiltersInput>>>;
  not?: InputMaybe<ComponentSharedIconsArrayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedIconsArrayFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedIconsArrayInput = {
  Icon?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedImageArrayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedImageArrayFiltersInput>>>;
  not?: InputMaybe<ComponentSharedImageArrayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedImageArrayFiltersInput>>>;
};

export type ComponentSharedImageArrayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedImagesArrayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedImagesArrayFiltersInput>>>;
  not?: InputMaybe<ComponentSharedImagesArrayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedImagesArrayFiltersInput>>>;
};

export type ComponentSharedImagesArrayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedMetaSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  socialNetwork?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedMetaSocialInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  socialNetwork?: InputMaybe<Enum_Componentsharedmetasocial_Socialnetwork>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedPackagingOptionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedPackagingOptionsFiltersInput>>>;
  not?: InputMaybe<ComponentSharedPackagingOptionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedPackagingOptionsFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedPackagingOptionsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedProcessArrayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedProcessArrayFiltersInput>>>;
  not?: InputMaybe<ComponentSharedProcessArrayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedProcessArrayFiltersInput>>>;
  step?: InputMaybe<IntFilterInput>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedProcessArrayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  step?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedProductAndTItleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedProductAndTItleFiltersInput>>>;
  not?: InputMaybe<ComponentSharedProductAndTItleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedProductAndTItleFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedProductAndTItleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedProductsSliderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedProductsSliderFiltersInput>>>;
  availability?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedProductsSliderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedProductsSliderFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedProductsSliderInput = {
  availability?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  canonicalURL?: InputMaybe<StringFilterInput>;
  keywords?: InputMaybe<StringFilterInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaRobots?: InputMaybe<StringFilterInput>;
  metaSocial?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  metaViewport?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  pageLink?: InputMaybe<StringFilterInput>;
  structuredData?: InputMaybe<JsonFilterInput>;
};

export type ComponentSharedSeoInput = {
  canonicalURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaImage?: InputMaybe<Scalars['ID']['input']>;
  metaRobots?: InputMaybe<Scalars['String']['input']>;
  metaSocial?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialInput>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaViewport?: InputMaybe<Scalars['String']['input']>;
  pageLink?: InputMaybe<Scalars['String']['input']>;
  structuredData?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentSharedSizesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSizesFiltersInput>>>;
  availability?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSizesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSizesFiltersInput>>>;
  range?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSizesInput = {
  availability?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedStatsArrayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedStatsArrayFiltersInput>>>;
  not?: InputMaybe<ComponentSharedStatsArrayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedStatsArrayFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedStatsArrayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTextAndDateArrayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTextAndDateArrayFiltersInput>>>;
  not?: InputMaybe<ComponentSharedTextAndDateArrayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTextAndDateArrayFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  year?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTextAndDateArrayInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTileInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTilesBrandsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTilesProductsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPageInput = {
  contact_emails?: InputMaybe<Array<InputMaybe<ComponentSharedContactEmailInput>>>;
  footer_image_1?: InputMaybe<Scalars['ID']['input']>;
  footer_image_2?: InputMaybe<Scalars['ID']['input']>;
  gmaps_src?: InputMaybe<Scalars['String']['input']>;
  hero_paragraph_1?: InputMaybe<Scalars['String']['input']>;
  hero_paragraph_2?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  telephones?: InputMaybe<Array<InputMaybe<ComponentShared3TextFieldsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  visit_address?: InputMaybe<Scalars['String']['input']>;
  visit_address_link?: InputMaybe<Scalars['String']['input']>;
  visit_paragraph_1?: InputMaybe<Scalars['String']['input']>;
  visit_title_1?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter'
}

export enum Enum_Menusmenuitem_Target {
  Blank = 'blank',
  Parent = 'parent',
  Self = 'self',
  Top = 'top'
}

export enum Enum_Page_Color {
  EBF5F1 = 'EBF5F1',
  F6EEEB = 'F6EEEB'
}

export enum Enum_Sitemapsitemap_Type {
  Default_hreflang = 'default_hreflang',
  Index = 'index'
}

export type EventFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  eventLink?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EventFiltersInput>;
  not?: InputMaybe<EventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  organizerName?: InputMaybe<StringFilterInput>;
  organizerWebsite?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  startDate?: InputMaybe<DateFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<StringFilterInput>;
};

export type EventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  eventLink?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerWebsite?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  venue?: InputMaybe<Scalars['String']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type ForBusinessFoodServicePageInput = {
  configurator?: InputMaybe<ComponentSharedConfiguratorInput>;
  hero_image?: InputMaybe<Scalars['ID']['input']>;
  hero_paragraph?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  tile_fruit_packaging?: InputMaybe<ComponentSharedTileInput>;
  tile_olive_packaging?: InputMaybe<ComponentSharedTileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ForBusinessPageInput = {
  hero_description?: InputMaybe<Scalars['String']['input']>;
  hero_tile_brands?: InputMaybe<ComponentSharedTileInput>;
  hero_tile_food_service?: InputMaybe<ComponentSharedTileInput>;
  hero_tile_private_label?: InputMaybe<ComponentSharedTileInput>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  promoted_slider?: InputMaybe<Array<InputMaybe<ComponentSharedProductsSliderInput>>>;
  promoted_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ForBusinessPrivateLabelPageInput = {
  configurator?: InputMaybe<ComponentSharedConfiguratorInput>;
  hero_image?: InputMaybe<Scalars['ID']['input']>;
  hero_paragraph?: InputMaybe<Scalars['String']['input']>;
  hero_paragraph_2?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  process_steps?: InputMaybe<Array<InputMaybe<ComponentSharedProcessArrayInput>>>;
  process_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  tiles_brands?: InputMaybe<ComponentSharedTilesBrandsInput>;
  tiles_our_products?: InputMaybe<ComponentSharedTilesProductsInput>;
  tiles_subtitle?: InputMaybe<Scalars['String']['input']>;
  tiles_title?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageInput = {
  brands_title?: InputMaybe<Scalars['String']['input']>;
  enviroment_1_paragraph?: InputMaybe<Scalars['String']['input']>;
  enviroment_1_title?: InputMaybe<Scalars['String']['input']>;
  enviroment_2_title?: InputMaybe<Scalars['String']['input']>;
  enviroment_mini_text?: InputMaybe<Array<InputMaybe<ComponentShared3TextFieldsInput>>>;
  fruits_mini_text?: InputMaybe<Array<InputMaybe<ComponentShared3TextFieldsInput>>>;
  fruits_paragraph?: InputMaybe<Scalars['String']['input']>;
  fruits_title?: InputMaybe<Scalars['String']['input']>;
  olives_mini_text?: InputMaybe<Array<InputMaybe<ComponentShared3TextFieldsInput>>>;
  olives_paragraph?: InputMaybe<Scalars['String']['input']>;
  olives_title?: InputMaybe<Scalars['String']['input']>;
  pl_paragraph?: InputMaybe<Scalars['String']['input']>;
  pl_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  quality_title_1?: InputMaybe<Scalars['String']['input']>;
  quality_title_2?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  social_title?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type MenusMenuFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MenusMenuFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  items?: InputMaybe<MenusMenuItemFiltersInput>;
  not?: InputMaybe<MenusMenuFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MenusMenuFiltersInput>>>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MenusMenuInput = {
  items?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MenusMenuItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MenusMenuItemFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MenusMenuItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MenusMenuItemFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  parent?: InputMaybe<MenusMenuItemFiltersInput>;
  root_menu?: InputMaybe<MenusMenuFiltersInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  target?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type MenusMenuItemInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  root_menu?: InputMaybe<Scalars['ID']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<Enum_Menusmenuitem_Target>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NewsPageInput = {
  hero_title?: InputMaybe<Scalars['String']['input']>;
  news_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PageFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInput = {
  color?: InputMaybe<Enum_Page_Color>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductAdditionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductAdditionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductAdditionFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductAdditionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductAdditionFiltersInput>>>;
  product_type_options?: InputMaybe<ProductTypeOptionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductAdditionInput = {
  image?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductBrandFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductBrandFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductBrandFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductBrandFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductBrandFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rank?: InputMaybe<IntFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductBrandInput = {
  logo?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategoryFiltersInput = {
  UID?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ProductCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductCategoryFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductCategoryFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductCategoryInput = {
  UID?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCutFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductCutFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductCutFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductCutFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductCutFiltersInput>>>;
  product_type_options?: InputMaybe<ProductTypeOptionFiltersInput>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductCutInput = {
  icon?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  featured?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  in_picture_size?: InputMaybe<ProductSizeFiltersInput>;
  in_picture_size_text?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  new?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ProductFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>;
  product_brand?: InputMaybe<ProductBrandFiltersInput>;
  product_categories?: InputMaybe<ProductCategoryFiltersInput>;
  product_cuts?: InputMaybe<ProductCutFiltersInput>;
  product_ingredients?: InputMaybe<ProductIngredientFiltersInput>;
  product_packagings?: InputMaybe<ProductSizeFiltersInput>;
  product_sizes?: InputMaybe<ProductTypeOptionSizeFiltersInput>;
  product_type?: InputMaybe<ProductTypeFiltersInput>;
  product_type_option?: InputMaybe<ProductTypeOptionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  short_description?: InputMaybe<StringFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductIngredientFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductIngredientFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductIngredientFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductIngredientFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductIngredientFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductIngredientInput = {
  icon?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  in_picture_size?: InputMaybe<Scalars['ID']['input']>;
  in_picture_size_text?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new?: InputMaybe<Scalars['Boolean']['input']>;
  product_brand?: InputMaybe<Scalars['ID']['input']>;
  product_categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_cuts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_ingredients?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_packagings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_sizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_type?: InputMaybe<Scalars['ID']['input']>;
  product_type_option?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSizeFiltersInput = {
  Notes?: InputMaybe<StringFilterInput>;
  UID?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ProductSizeFiltersInput>>>;
  children?: InputMaybe<ProductSizeFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  in_picture_title?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductSizeFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductSizeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductSizeFiltersInput>>>;
  parent?: InputMaybe<ProductSizeFiltersInput>;
  product_sizes_container?: InputMaybe<ProductSizesContainerFiltersInput>;
  products?: InputMaybe<ProductFiltersInput>;
  rank?: InputMaybe<IntFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductSizeInput = {
  Image?: InputMaybe<Scalars['ID']['input']>;
  Notes?: InputMaybe<Scalars['String']['input']>;
  UID?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  in_picture_title?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  product_sizes_container?: InputMaybe<Scalars['ID']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductSizesContainerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductSizesContainerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductSizesContainerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductSizesContainerFiltersInput>>>;
  product_sizes?: InputMaybe<ProductSizeFiltersInput>;
  rank?: InputMaybe<IntFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductSizesContainerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  product_sizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductStuffingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductStuffingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductStuffingFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductStuffingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductStuffingFiltersInput>>>;
  product_type_options?: InputMaybe<ProductTypeOptionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductStuffingInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductTypeFiltersInput = {
  UID?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ProductTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  hero_paragraph_1?: InputMaybe<StringFilterInput>;
  hero_paragraph_2?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductTypeFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductTypeFiltersInput>>>;
  page_title?: InputMaybe<StringFilterInput>;
  product_type_options?: InputMaybe<ProductTypeOptionFiltersInput>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rank?: InputMaybe<IntFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductTypeInput = {
  UID?: InputMaybe<Scalars['String']['input']>;
  brochure?: InputMaybe<Scalars['ID']['input']>;
  hero_paragraph_1?: InputMaybe<Scalars['String']['input']>;
  hero_paragraph_2?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['ID']['input']>;
  logistics_brochure?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packaging_brochure?: InputMaybe<Scalars['ID']['input']>;
  page_title?: InputMaybe<Scalars['String']['input']>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  seo?: InputMaybe<Array<InputMaybe<ComponentSharedSeoInput>>>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTypeOptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductTypeOptionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  hero_paragraph_1?: InputMaybe<StringFilterInput>;
  hero_paragraph_2?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductTypeOptionFiltersInput>;
  main?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductTypeOptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductTypeOptionFiltersInput>>>;
  product_additions?: InputMaybe<ProductAdditionFiltersInput>;
  product_cuts?: InputMaybe<ProductCutFiltersInput>;
  product_stuffings?: InputMaybe<ProductStuffingFiltersInput>;
  product_type?: InputMaybe<ProductTypeFiltersInput>;
  product_type_option_sizes?: InputMaybe<ProductTypeOptionSizeFiltersInput>;
  product_variations?: InputMaybe<ProductVariationFiltersInput>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rank?: InputMaybe<IntFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  subtypes?: InputMaybe<ProductTypeOptionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductTypeOptionInput = {
  hero_paragraph_1?: InputMaybe<Scalars['String']['input']>;
  hero_paragraph_2?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['ID']['input']>;
  main?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_additions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_cuts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_stuffings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_type?: InputMaybe<Scalars['ID']['input']>;
  product_type_option_sizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  product_variations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ProductTypeOptionSizeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductTypeOptionSizeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductTypeOptionSizeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductTypeOptionSizeFiltersInput>>>;
  product_type_options?: InputMaybe<ProductTypeOptionFiltersInput>;
  products?: InputMaybe<ProductFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rank?: InputMaybe<IntFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  size?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type ProductTypeOptionSizeInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductVariationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductVariationFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductVariationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductVariationFiltersInput>>>;
  product_type_options?: InputMaybe<ProductTypeOptionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductVariationInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductsPageInput = {
  hero_subtitle?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  process_steps?: InputMaybe<Array<InputMaybe<ComponentSharedProcessArrayInput>>>;
  promoted_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsProductTypeOptionsPageInput = {
  configurator_configurator?: InputMaybe<ComponentSharedConfiguratorInput>;
  cuts_black_olives?: InputMaybe<Array<InputMaybe<ComponentSharedProductAndTItleInput>>>;
  cuts_green_olives?: InputMaybe<Array<InputMaybe<ComponentSharedProductAndTItleInput>>>;
  cuts_title?: InputMaybe<Scalars['String']['input']>;
  hero_circle?: InputMaybe<Array<InputMaybe<ComponentSharedCirclesComponentInput>>>;
  hero_paragraph?: InputMaybe<Scalars['String']['input']>;
  hero_subtitle?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  packaging_image?: InputMaybe<Scalars['ID']['input']>;
  packaging_sizes?: InputMaybe<Array<InputMaybe<ComponentSharedPackagingOptionsInput>>>;
  packaging_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  sizes_size?: InputMaybe<Array<InputMaybe<ComponentSharedSizesInput>>>;
  sizes_title?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsProductTypePackagingPageInput = {
  configurator_configurator?: InputMaybe<ComponentSharedConfiguratorInput>;
  hero_packaging_image?: InputMaybe<Scalars['ID']['input']>;
  hero_packaging_options?: InputMaybe<Array<InputMaybe<ComponentSharedPackagingOptionsInput>>>;
  hero_subtitle?: InputMaybe<Scalars['String']['input']>;
  promoted_slider?: InputMaybe<Array<InputMaybe<ComponentSharedProductsSliderInput>>>;
  promoted_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsProductTypePageInput = {
  configurator_configurator?: InputMaybe<ComponentSharedConfiguratorInput>;
  cuts_cut?: InputMaybe<Array<InputMaybe<ComponentSharedProductAndTItleInput>>>;
  cuts_title?: InputMaybe<Scalars['String']['input']>;
  extras_image?: InputMaybe<Array<InputMaybe<ComponentSharedExtrasImagesInput>>>;
  extras_title?: InputMaybe<Scalars['String']['input']>;
  hero_circle?: InputMaybe<Array<InputMaybe<ComponentSharedCirclesComponentInput>>>;
  hero_paragraph_1?: InputMaybe<Scalars['String']['input']>;
  hero_paragraph_2?: InputMaybe<Scalars['String']['input']>;
  hero_subtitle?: InputMaybe<Scalars['String']['input']>;
  hero_title?: InputMaybe<Scalars['String']['input']>;
  packaging_image?: InputMaybe<Scalars['ID']['input']>;
  packaging_options?: InputMaybe<Array<InputMaybe<ComponentSharedPackagingOptionsInput>>>;
  packaging_title?: InputMaybe<Scalars['String']['input']>;
  promoted_slider?: InputMaybe<Array<InputMaybe<ComponentSharedProductsSliderInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicationState {
  LIVE = 'LIVE',
  PREVIEW = 'PREVIEW'
}

export type SitemapSitemapCacheFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SitemapSitemapCacheFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SitemapSitemapCacheFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SitemapSitemapCacheFiltersInput>>>;
  sitemap_id?: InputMaybe<IntFilterInput>;
  sitemap_json?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SitemapSitemapCacheInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sitemap_id?: InputMaybe<Scalars['Int']['input']>;
  sitemap_json?: InputMaybe<Scalars['JSON']['input']>;
};

export type SitemapSitemapFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SitemapSitemapFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  delta?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  link_count?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SitemapSitemapFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SitemapSitemapFiltersInput>>>;
  sitemap_string?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SitemapSitemapInput = {
  delta?: InputMaybe<Scalars['Int']['input']>;
  link_count?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sitemap_string?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Sitemapsitemap_Type>;
};

export type SlugifySlugFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SlugifySlugFiltersInput>>>;
  count?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SlugifySlugFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SlugifySlugFiltersInput>>>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SlugifySlugInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  sitemap_exclude?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type BrandedProductSizesQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BrandedProductSizesQuery = { productSizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, parent?: { data?: { id?: string | null } | null } | null, product_sizes_container?: { data?: { id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null } | null } | null } | null }> } | null, parents?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null }> } | null } | null }> } | null } | null }> } | null };

export type PsFragment = { id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null };

export type PspasdFragment = { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null }> } | null } | null }> } | null } | null }> };

export type BlogPostAttributesFragment = { id?: string | null, attributes?: { Title?: string | null, Date?: any | null, createdAt?: any | null, IntroText?: string | null, Text?: string | null, locale?: string | null, slug?: string | null, Image?: { data?: { attributes?: { url: string } | null } | null } | null } | null };

export type BrandFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, subtitle?: string | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type BrandInfoFragment = { name?: string | null, slug: string, subtitle?: string | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type BrandWithProductsFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, subtitle?: string | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null }> } | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type ProductBrandFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null };

export type ImageFragment = { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type ProductFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null };

export type ProductBrandInfoFragment = { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null };

export type ProductCategoriesFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type ProductCutsFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type ProductIngredientsFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type ProductBrandsFragment = { attributes?: { product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null } | null };

export type ProductSizesFragment = { attributes?: { product_packagings?: { data: Array<{ attributes?: { product_sizes_container?: { data?: { attributes?: { name?: string | null } | null } | null } | null } | null }> } | null } | null };

export type ProductTypesFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type ProductVarietiesFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null };

export type SeoFragment = { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null };

export type BrandsPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type BrandsPageQuery = { brandsPage?: { data?: { attributes?: { title: string, hero_title?: string | null, tiles_title?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null, tiles_tile_private_label?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, tiles_tile_packaging?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null } | null, productBrands?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, subtitle?: string | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, productTypes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, productTypeOptions?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string } | null }> } | null, productVariations?: { data: Array<{ id?: string | null, attributes?: { name?: string | null } | null }> } | null, productCuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, productIngredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, productSizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null } | null }> } | null };

export type BrandsPageProductsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  brand_slug?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  product_cuts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  product_sizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  product_ingredients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  product_type_options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandsPageProductsQuery = { products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }>, meta: { pagination: { page: number, pageSize: number, total: number, pageCount: number } } } | null };

export type BrandsPageProductFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type BrandsProductPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type BrandsProductPageQuery = { brandsProductPage?: { data?: { attributes?: { tiles_title?: string | null, tiles_tile_private_label?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null, tiles_tile_packaging?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null } | null };

export type GetBrandsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetBrandsQuery = { productBrands?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, subtitle?: string | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null };

export type GetBrandsAndProductsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetBrandsAndProductsQuery = { productBrands?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, subtitle?: string | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null }> } | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null };

export type GetBrandBySlugQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBrandBySlugQuery = { productBrands?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, subtitle?: string | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null };

export type GetAllProductsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllProductsQuery = { products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type GetSingleBrandAndProductsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  brand_slug?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSingleBrandAndProductsQuery = { productBrands?: { data: Array<{ attributes?: { name?: string | null, slug: string, subtitle?: string | null, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, products?: { data: Array<{ attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null };

export type GetProductsByBrandSlugQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  brand_slug?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductsByBrandSlugQuery = { products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type CompanyPage1QueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type CompanyPage1Query = { companyPage?: { data?: { id?: string | null, attributes?: { title: string, hero_title?: string | null, hero_introduction_title?: string | null, hero_introduction_paragraph?: string | null, certificates_certificates?: string | null, certificates_awards?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null, certificates_certificates_badge?: Array<{ image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null> | null, certificates_awards_badges?: Array<{ image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type CompanyPage2QueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type CompanyPage2Query = { companyPage?: { data?: { id?: string | null, attributes?: { title: string, whoweare_title?: string | null, Whoweare_paragraphs?: string | null, history_title?: string | null, facilities_title?: string | null, facilities_paragraph_1?: string | null, facilities_paragraph_2?: string | null, facilities_paragraph_3?: string | null, environmentsocial_title?: string | null, environmentsocial_quote?: string | null, environmentsocial_social_title?: string | null, environmentsocial_paragraph?: string | null, water_title?: string | null, water_description?: string | null, energy_title?: string | null, energy_description?: string | null, recycling_title?: string | null, recycling_description?: string | null, whoweare_largeImage?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, whoweare_smallImage?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, history_details?: Array<{ text?: string | null, year?: string | null } | null> | null, history_video?: { data?: { attributes?: { url: string } | null } | null } | null, icons_iconswithtext?: Array<{ text?: string | null, Icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null> | null, facilities_largeImage?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, facilities_smallImage1?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, facilities_smallImage2?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, facilities_video?: { data?: { attributes?: { url: string } | null } | null } | null, environmentsocial_video?: { data?: { attributes?: { url: string } | null } | null } | null, environmentsocial_stats?: Array<{ text?: string | null } | null> | null } | null } | null } | null };

export type ContactPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ContactPageQuery = { contactPage?: { data?: { id?: string | null, attributes?: { hero_title?: string | null, hero_paragraph_1?: string | null, hero_paragraph_2?: string | null, visit_title_1?: string | null, visit_paragraph_1?: string | null, visit_address?: string | null, visit_address_link?: string | null, gmaps_src?: string | null, telephones?: Array<{ text?: string | null } | null> | null, contact_emails?: Array<{ department_name?: string | null, department_email?: string | null } | null> | null, footer_image_1?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, footer_image_2?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type FoodServicePageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type FoodServicePageQuery = { forBusinessFoodServicePage?: { data?: { attributes?: { title?: string | null, hero_title?: string | null, hero_paragraph?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null, hero_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, tile_olive_packaging?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, tile_fruit_packaging?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, configurator?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, bg_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null } | null, productTypes?: { data: Array<{ attributes?: { name?: string | null, slug: string, packaging_brochure?: { data?: { attributes?: { url: string, alternativeText?: string | null } | null } | null } | null } | null }> } | null };

export type ForBusinessPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ForBusinessPageQuery = { forBusinessPage?: { data?: { id?: string | null, attributes?: { hero_title?: string | null, hero_description?: string | null, promoted_title?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null, hero_tile_private_label?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, hero_tile_food_service?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, hero_tile_brands?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null } | null, newProducts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null }> } | null };

export type NewProductsFragment = { newProducts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null }> } | null };

export type ProductCardFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null };

export type PrivateLabelPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type PrivateLabelPageQuery = { forBusinessPrivateLabelPage?: { data?: { attributes?: { title?: string | null, hero_title?: string | null, hero_paragraph?: string | null, hero_paragraph_2?: string | null, process_title?: string | null, tiles_title?: string | null, tiles_subtitle?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null, hero_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, process_steps?: Array<{ text?: string | null, step?: number | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null> | null, configurator?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, bg_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, tiles_our_products?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null, tiles_brands?: { title?: string | null, subtitle?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null } | null };

export type HomePageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomePageQuery = { homePage?: { data?: { id?: string | null, attributes?: { quality_title_1?: string | null, quality_title_2?: string | null, olives_title?: string | null, olives_paragraph?: string | null, fruits_title?: string | null, fruits_paragraph?: string | null, pl_title?: string | null, pl_paragraph?: string | null, brands_title?: string | null, enviroment_1_title?: string | null, enviroment_1_paragraph?: string | null, enviroment_2_title?: string | null, social_title?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null, olives_mini_text?: Array<{ text?: string | null } | null> | null, fruits_mini_text?: Array<{ text?: string | null } | null> | null, enviroment_mini_text?: Array<{ text?: string | null } | null> | null } | null } | null } | null, oliveOptions?: { data: Array<{ id?: string | null, attributes?: { slug: string, product_type_options?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null } | null }> } | null, fruitOptions?: { data: Array<{ id?: string | null, attributes?: { slug: string, product_type_options?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null } | null }> } | null, featuredProducts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null } | null }> } | null };

export type FeaturedProductsFragment = { featuredProducts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null } | null }> } | null };

export type OliveOptionsFragment = { oliveOptions?: { data: Array<{ id?: string | null, attributes?: { slug: string, product_type_options?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null } | null }> } | null };

export type FruitOptionsFragment = { fruitOptions?: { data: Array<{ id?: string | null, attributes?: { slug: string, product_type_options?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null } | null }> } | null };

export type GetProductTypesAndSubtypesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetProductTypesAndSubtypesQuery = { productTypes?: { data: Array<{ attributes?: { slug: string, name?: string | null, product_type_options?: { data: Array<{ attributes?: { name?: string | null, slug: string } | null }> } | null } | null }> } | null };

export type NewsPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type NewsPageQuery = { newsPage?: { data?: { attributes?: { hero_title?: string | null, news_title?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null, events?: { data: Array<{ id?: string | null, attributes?: { title: string, startDate?: any | null, endDate?: any | null, venue?: string | null, eventLink: string, organizerName?: string | null, organizerWebsite?: string | null, description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null };

export type BlogPostsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type BlogPostsQuery = { blogPosts?: { data: Array<{ id?: string | null, attributes?: { Title?: string | null, Date?: any | null, createdAt?: any | null, IntroText?: string | null, Text?: string | null, locale?: string | null, slug?: string | null, Image?: { data?: { attributes?: { url: string } | null } | null } | null } | null }>, meta: { pagination: { total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type CheckIfBlogPostExistsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckIfBlogPostExistsQuery = { blogPosts?: { data: Array<{ id?: string | null }> } | null };

export type GetBlogPostBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlogPostBySlugQuery = { blogPosts?: { data: Array<{ id?: string | null, attributes?: { slug?: string | null, Title?: string | null, Date?: any | null, Text?: string | null, Image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, SEO?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null }> } | null };

export type GetEventsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetEventsQuery = { events?: { data: Array<{ id?: string | null, attributes?: { title: string, startDate?: any | null, endDate?: any | null, venue?: string | null, eventLink: string, organizerName?: string | null, organizerWebsite?: string | null, description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null };

export type EventInformationFragment = { id?: string | null, attributes?: { title: string, startDate?: any | null, endDate?: any | null, venue?: string | null, eventLink: string, organizerName?: string | null, organizerWebsite?: string | null, description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type ProductsProductTypeOptionPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ProductsProductTypeOptionPageQuery = { productsProductTypeOptionsPage?: { data?: { attributes?: { hero_subtitle?: string | null, hero_paragraph?: string | null, cuts_title?: string | null, sizes_title?: string | null, packaging_title?: string | null, packaging_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, packaging_sizes?: Array<{ title?: string | null } | null> | null } | null } | null } | null };

export type ProductsProductTypePackagingPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ProductsProductTypePackagingPageQuery = { productsProductTypePackagingPage?: { data?: { attributes?: { hero_subtitle?: string | null, hero_packaging_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, hero_packaging_options?: Array<{ title?: string | null } | null> | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null }> } | null };

export type GetProductBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProductBySlugQuery = { products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type CheckIfProductExistsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CheckIfProductExistsQuery = { products?: { data: Array<{ id?: string | null }> } | null };

export type GetProductVariationsQueryVariables = Exact<{
  product_type_option?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductVariationsQuery = { products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null } | null }> } | null };

export type GetProductTypesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductTypesQuery = { productTypes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, productsPage?: { data?: { attributes?: { hero_title?: string | null, hero_subtitle?: string | null, promoted_title?: string | null, seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null, processSteps?: { data?: { attributes?: { process_steps?: Array<{ text?: string | null, step?: number | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type ProcessStepsFragment = { processSteps?: { data?: { attributes?: { process_steps?: Array<{ text?: string | null, step?: number | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type ProductTypeFragment = { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type GetCountOfProductVariationsQueryVariables = Exact<{
  product_type_option?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCountOfProductVariationsQuery = { products?: { meta: { pagination: { total: number } } } | null };

export type GetRandomPrePackagedProductsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRandomPrePackagedProductsQuery = { products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type GetProductTypePageDataQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductTypePageDataQuery = { productTypes?: { data: Array<{ attributes?: { slug: string, name?: string | null, page_title?: string | null, hero_paragraph_1?: string | null, hero_paragraph_2?: string | null, product_type_options?: { data: Array<{ attributes?: { name?: string | null, slug: string, main?: boolean | null, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, brochure?: { data?: { attributes?: { url: string } | null } | null } | null, packaging_brochure?: { data?: { attributes?: { url: string } | null } | null } | null } | null }> } | null, lozalized?: { data: Array<{ id?: string | null, attributes?: { slug: string, localizations?: { data: Array<{ id?: string | null, attributes?: { locale?: string | null, slug: string } | null }> } | null } | null }> } | null, productsProductTypePage?: { data?: { attributes?: { hero_title?: string | null, hero_subtitle?: string | null, hero_paragraph_1?: string | null, hero_paragraph_2?: string | null, cuts_title?: string | null, extras_title?: string | null, packaging_title?: string | null, packaging_image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, packaging_options?: Array<{ title?: string | null } | null> | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, description?: string | null, in_picture_size_text?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string, logo?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, products?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, short_description?: string | null, image?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_brand?: { data?: { attributes?: { name?: string | null, slug: string } | null } | null } | null } | null }> } | null } | null } | null } | null, product_categories?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_cuts?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_ingredients?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null }> } | null, product_type?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null } | null } | null, product_type_option?: { data?: { id?: string | null, attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, size?: string | null, slug: string } | null }> } | null } | null } | null } | null, product_packagings?: { data: Array<{ id?: string | null }> } | null, product_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null } | null }> } | null, in_picture_size?: { data?: { attributes?: { name?: string | null, parent?: { data?: { attributes?: { in_picture_title?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type GetProductTypeOptionsCutsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductTypeOptionsCutsQuery = { productTypeOptions?: { data: Array<{ attributes?: { name?: string | null, product_cuts?: { data: Array<{ attributes?: { name?: string | null, slug: string, image?: { data: Array<{ attributes?: { url: string, alternativeText?: string | null, caption?: string | null } | null }> } | null } | null }> } | null } | null }> } | null };

export type CheckIfProductTypeExistsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckIfProductTypeExistsQuery = { productTypes?: { data: Array<{ id?: string | null }> } | null };

export type CheckIfProductSubTypeExistsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckIfProductSubTypeExistsQuery = { productTypeOptions?: { data: Array<{ id?: string | null }> } | null };

export type GetProductSubTypeDataQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  product_type_option?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductSubTypeDataQuery = { productTypeOptions?: { data: Array<{ attributes?: { name?: string | null, slug: string, hero_paragraph_1?: string | null, hero_paragraph_2?: string | null, product_type?: { data?: { attributes?: { slug: string, page_title?: string | null, brochure?: { data?: { attributes?: { url: string } | null } | null } | null, packaging_brochure?: { data?: { attributes?: { url: string } | null } | null } | null } | null } | null } | null, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_cuts?: { data: Array<{ attributes?: { name?: string | null, slug: string, image?: { data: Array<{ attributes?: { url: string, alternativeText?: string | null, caption?: string | null } | null }> } | null } | null }> } | null, product_variations?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null, product_stuffings?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null, product_additions?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, size?: string | null, width?: number | null, height?: number | null, image?: { data: Array<{ attributes?: { url: string, alternativeText?: string | null, caption?: string | null } | null }> } | null } | null }> } | null, subtypes?: { data: Array<{ attributes?: { name?: string | null, slug: string, icon?: { data?: { attributes?: { url: string, alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null, mime: string, size: number, previewUrl?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null, product_cuts?: { data: Array<{ attributes?: { name?: string | null, slug: string, image?: { data: Array<{ attributes?: { url: string, alternativeText?: string | null, caption?: string | null } | null }> } | null } | null }> } | null, product_stuffings?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null, product_additions?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null, product_variations?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null, product_type_option_sizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, slug: string, width?: number | null, height?: number | null, size?: string | null, image?: { data: Array<{ attributes?: { url: string, alternativeText?: string | null, caption?: string | null } | null }> } | null, product_type_options?: { data: Array<{ id?: string | null, attributes?: { slug: string, name?: string | null } | null }> } | null } | null }> } | null } | null }> } | null } | null }> } | null, allProductTypeOptions?: { data: Array<{ attributes?: { slug: string, name?: string | null, subtypes?: { data: Array<{ id?: string | null }> } | null, product_type?: { data?: { attributes?: { slug: string } | null } | null } | null } | null }> } | null, lozalizedSubType?: { data: Array<{ id?: string | null, attributes?: { slug: string, localizations?: { data: Array<{ id?: string | null, attributes?: { locale?: string | null, slug: string } | null }> } | null } | null }> } | null, lozalizedType?: { data: Array<{ id?: string | null, attributes?: { slug: string, localizations?: { data: Array<{ id?: string | null, attributes?: { locale?: string | null, slug: string } | null }> } | null } | null }> } | null };

export type ProductSizesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ProductSizesQuery = { productSizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, parent?: { data?: { id?: string | null } | null } | null, product_sizes_container?: { data?: { id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null } | null } | null } | null }> } | null, parents?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, Image?: { data?: { attributes?: { hash: string, url: string } | null } | null } | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null }> } | null } | null }> } | null } | null }> } | null, productTypes?: { data: Array<{ attributes?: { name?: string | null, slug: string, packaging_brochure?: { data?: { attributes?: { url: string, alternativeText?: string | null } | null } | null } | null } | null }> } | null };

export type PspFragment = { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, Image?: { data?: { attributes?: { hash: string, url: string } | null } | null } | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null }> } | null } | null }> } | null } | null }> };

export type ProductSizesBySlugQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  product_slug?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductSizesBySlugQuery = { productSizes?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, parent?: { data?: { id?: string | null } | null } | null, product_sizes_container?: { data?: { id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null } | null } | null } | null }> } | null, parents?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, Image?: { data?: { attributes?: { hash: string, url: string } | null } | null } | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null, children?: { data: Array<{ id?: string | null, attributes?: { name?: string | null, rank?: number | null } | null }> } | null } | null }> } | null } | null }> } | null };

export type NewsTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type NewsTitleQuery = { newsPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type BrandsTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type BrandsTitleQuery = { brandsPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ProductsTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ProductsTitleQuery = { productsPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ContactTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ContactTitleQuery = { contactPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type ForBusinessTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ForBusinessTitleQuery = { forBusinessPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type PrivateLabelTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type PrivateLabelTitleQuery = { forBusinessPrivateLabelPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type FoodServiceTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type FoodServiceTitleQuery = { forBusinessFoodServicePage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type HomeTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type HomeTitleQuery = { homePage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export type CompanyTitleQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type CompanyTitleQuery = { companyPage?: { data?: { attributes?: { seo?: { metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, metaRobots?: string | null, structuredData?: any | null, metaViewport?: string | null, canonicalURL?: string | null, metaImage?: { data?: { attributes?: { url: string } | null } | null } | null, metaSocial?: Array<{ id: string, title?: string | null, description?: string | null, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, image?: { data?: { attributes?: { url: string } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export const PsFragmentDoc = gql`
    fragment ps on ProductSizeEntity {
  id
  attributes {
    name
    rank
  }
}
    `;
export const PspasdFragmentDoc = gql`
    fragment pspasd on ProductSizeEntityResponseCollection {
  data {
    ...ps
    attributes {
      children {
        data {
          ...ps
          attributes {
            children {
              data {
                ...ps
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const BlogPostAttributesFragmentDoc = gql`
    fragment BlogPostAttributes on BlogPostEntity {
  id
  attributes {
    Title
    Date
    createdAt
    IntroText
    Text
    locale
    slug
    Image {
      data {
        attributes {
          url
        }
      }
    }
  }
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on UploadFileEntityResponse {
  data {
    attributes {
      url
      alternativeText
      caption
      width
      height
      formats
      hash
      ext
      mime
      size
      previewUrl
      createdAt
      updatedAt
    }
  }
}
    `;
export const BrandInfoFragmentDoc = gql`
    fragment BrandInfo on ProductBrand {
  name
  slug
  subtitle
  logo {
    ...Image
  }
}
    `;
export const BrandFragmentDoc = gql`
    fragment Brand on ProductBrandEntity {
  id
  attributes {
    ...BrandInfo
  }
}
    `;
export const ProductBrandFragmentDoc = gql`
    fragment ProductBrand on ProductEntity {
  id
  attributes {
    name
    slug
    image {
      ...Image
    }
    short_description
    product_packagings {
      data {
        id
      }
    }
  }
}
    `;
export const BrandWithProductsFragmentDoc = gql`
    fragment BrandWithProducts on ProductBrandEntity {
  id
  attributes {
    ...BrandInfo
    products {
      data {
        ...ProductBrand
      }
    }
  }
}
    `;
export const ProductBrandInfoFragmentDoc = gql`
    fragment ProductBrandInfo on ProductBrandEntity {
  attributes {
    name
    slug
    logo {
      ...Image
    }
    products {
      data {
        id
        attributes {
          name
          slug
          image {
            ...Image
          }
          short_description
          product_packagings {
            data {
              id
            }
          }
          product_brand {
            data {
              attributes {
                name
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ProductCategoriesFragmentDoc = gql`
    fragment ProductCategories on ProductCategoryEntity {
  id
  attributes {
    name
    slug
    icon {
      ...Image
    }
  }
}
    `;
export const ProductCutsFragmentDoc = gql`
    fragment ProductCuts on ProductCutEntity {
  id
  attributes {
    name
    slug
    icon {
      ...Image
    }
  }
}
    `;
export const ProductIngredientsFragmentDoc = gql`
    fragment ProductIngredients on ProductIngredientEntity {
  id
  attributes {
    name
    slug
    icon {
      ...Image
    }
  }
}
    `;
export const ProductTypesFragmentDoc = gql`
    fragment ProductTypes on ProductTypeEntity {
  id
  attributes {
    name
    slug
    icon {
      ...Image
    }
  }
}
    `;
export const ProductVarietiesFragmentDoc = gql`
    fragment ProductVarieties on ProductTypeOptionEntity {
  id
  attributes {
    name
    slug
    icon {
      ...Image
    }
    product_type_option_sizes {
      data {
        id
        attributes {
          name
          size
          slug
        }
      }
    }
  }
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on ProductEntity {
  id
  attributes {
    name
    slug
    short_description
    description
    image {
      ...Image
    }
    product_brand {
      data {
        ...ProductBrandInfo
      }
    }
    product_categories {
      data {
        ...ProductCategories
      }
    }
    product_cuts {
      data {
        ...ProductCuts
      }
    }
    product_ingredients {
      data {
        ...ProductIngredients
      }
    }
    product_type {
      data {
        ...ProductTypes
      }
    }
    product_type_option {
      data {
        ...ProductVarieties
      }
    }
    product_packagings {
      data {
        id
      }
    }
    product_sizes {
      data {
        id
        attributes {
          name
          slug
          size
        }
      }
    }
    in_picture_size_text
    in_picture_size {
      data {
        attributes {
          name
          parent {
            data {
              attributes {
                in_picture_title
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ProductBrandsFragmentDoc = gql`
    fragment ProductBrands on ProductEntity {
  attributes {
    product_brand {
      data {
        attributes {
          name
        }
      }
    }
  }
}
    `;
export const ProductSizesFragmentDoc = gql`
    fragment ProductSizes on ProductEntity {
  attributes {
    product_packagings {
      data {
        attributes {
          product_sizes_container {
            data {
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const SeoFragmentDoc = gql`
    fragment seo on ComponentSharedSeo {
  metaTitle
  metaDescription
  metaImage {
    data {
      attributes {
        url
      }
    }
  }
  keywords
  metaRobots
  structuredData
  metaViewport
  canonicalURL
  metaSocial {
    id
    title
    description
    image {
      data {
        attributes {
          url
        }
      }
    }
    socialNetwork
  }
}
    `;
export const BrandsPageProductFragmentDoc = gql`
    fragment BrandsPageProduct on ProductEntity {
  id
  attributes {
    name
    slug
    short_description
    image {
      ...Image
    }
  }
}
    `;
export const NewProductsFragmentDoc = gql`
    fragment NewProducts on Query {
  newProducts: products(
    locale: $locale
    filters: {new: {eq: true}}
    pagination: {limit: 6}
  ) {
    data {
      id
      attributes {
        name
        slug
        short_description
        image {
          ...Image
        }
        product_brand {
          data {
            attributes {
              name
            }
          }
        }
        product_packagings {
          data {
            id
          }
        }
      }
    }
  }
}
    `;
export const ProductCardFragmentDoc = gql`
    fragment ProductCard on ProductEntity {
  id
  attributes {
    name
    slug
    short_description
    image {
      ...Image
    }
    product_brand {
      data {
        attributes {
          name
        }
      }
    }
    product_packagings {
      data {
        id
      }
    }
  }
}
    `;
export const FeaturedProductsFragmentDoc = gql`
    fragment FeaturedProducts on Query {
  featuredProducts: products(
    locale: $locale
    filters: {featured: {eq: true}, product_brand: {name: {not: null}, and: {slug: {not: null}}}}
    pagination: {limit: $limit}
  ) {
    data {
      id
      attributes {
        image {
          ...Image
        }
        name
        slug
        product_brand {
          data {
            attributes {
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const OliveOptionsFragmentDoc = gql`
    fragment OliveOptions on Query {
  oliveOptions: productTypes(
    locale: $locale
    filters: {slug: {in: ["elies", "olives"]}}
  ) {
    data {
      id
      attributes {
        slug
        product_type_options(filters: {main: {eq: true}}, sort: "rank:asc") {
          data {
            id
            attributes {
              name
              slug
              icon {
                ...Image
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const FruitOptionsFragmentDoc = gql`
    fragment FruitOptions on Query {
  fruitOptions: productTypes(
    locale: $locale
    filters: {slug: {in: ["fruits", "froyta"]}}
  ) {
    data {
      id
      attributes {
        slug
        product_type_options(filters: {main: {eq: true}}, sort: "rank:asc") {
          data {
            id
            attributes {
              name
              slug
              icon {
                ...Image
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const EventInformationFragmentDoc = gql`
    fragment EventInformation on EventEntity {
  id
  attributes {
    title
    startDate
    endDate
    venue
    eventLink
    organizerName
    organizerWebsite
    description
    image {
      ...Image
    }
  }
}
    `;
export const ProcessStepsFragmentDoc = gql`
    fragment ProcessSteps on Query {
  processSteps: productsPage(locale: $locale) {
    data {
      attributes {
        process_steps {
          image {
            ...Image
          }
          text
          step
        }
      }
    }
  }
}
    `;
export const ProductTypeFragmentDoc = gql`
    fragment ProductType on ProductTypeEntity {
  id
  attributes {
    name
    slug
    icon {
      ...Image
    }
  }
}
    `;
export const PspFragmentDoc = gql`
    fragment psp on ProductSizeEntityResponseCollection {
  data {
    ...ps
    attributes {
      Image {
        data {
          attributes {
            hash
            url
          }
        }
      }
      children(pagination: {page: 1, pageSize: 200}) {
        data {
          ...ps
          attributes {
            children(pagination: {page: 1, pageSize: 200}) {
              data {
                ...ps
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const BrandedProductSizesDocument = gql`
    query BrandedProductSizes($productId: ID) {
  productSizes(
    pagination: {page: 1, pageSize: 200}
    filters: {product_sizes_container: {id: {notNull: true}}, products: {id: {eq: $productId}}}
  ) {
    data {
      id
      attributes {
        name
        rank
        parent {
          data {
            id
          }
        }
      }
      attributes {
        product_sizes_container {
          data {
            id
            attributes {
              name
              rank
            }
          }
        }
      }
    }
  }
  parents: productSizes(
    pagination: {page: 1, pageSize: 200}
    filters: {parent: {id: {null: true}}}
  ) {
    ...pspasd
  }
}
    ${PspasdFragmentDoc}
${PsFragmentDoc}`;
export const BrandsPageDocument = gql`
    query BrandsPage($locale: I18NLocaleCode) {
  brandsPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
        title
        hero_title
        tiles_title
        tiles_tile_private_label {
          title
          subtitle
          image {
            ...Image
          }
        }
        tiles_tile_packaging {
          title
          subtitle
          image {
            ...Image
          }
        }
      }
    }
  }
  productBrands(
    pagination: {page: 1, pageSize: 100}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      ...Brand
    }
  }
  productTypes(
    pagination: {page: 1, pageSize: 100}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      id
      attributes {
        name
        slug
        icon {
          ...Image
        }
      }
    }
  }
  productTypeOptions(
    pagination: {page: 1, pageSize: 100}
    filters: {subtypes: {id: null}, products: {id: {notNull: true}}}
    locale: $locale
  ) {
    data {
      id
      attributes {
        name
        slug
      }
    }
  }
  productVariations(pagination: {page: 1, pageSize: 100}, locale: $locale) {
    data {
      id
      attributes {
        name
      }
    }
  }
  productCuts(pagination: {page: 1, pageSize: 100}, locale: $locale) {
    data {
      id
      attributes {
        name
        slug
        icon {
          ...Image
        }
      }
    }
  }
  productIngredients(pagination: {page: 1, pageSize: 100}, locale: $locale) {
    data {
      id
      attributes {
        name
        slug
        icon {
          ...Image
        }
      }
    }
  }
  productSizes(pagination: {page: 1, pageSize: 100}, locale: $locale) {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    ${SeoFragmentDoc}
${ImageFragmentDoc}
${BrandFragmentDoc}
${BrandInfoFragmentDoc}`;
export const BrandsPageProductsDocument = gql`
    query BrandsPageProducts($locale: I18NLocaleCode, $brand_slug: String, $product_type: [String], $product_cuts: [String], $product_sizes: [String], $product_ingredients: [String], $product_type_options: [String], $page: Int) {
  products(
    filters: {product_brand: {slug: {eq: $brand_slug}}, product_type: {slug: {in: $product_type}}, product_cuts: {slug: {in: $product_cuts}}, product_sizes: {slug: {in: $product_sizes}}, product_ingredients: {slug: {in: $product_ingredients}}, product_type_option: {slug: {in: $product_type_options}}}
    pagination: {page: $page, pageSize: 24}
    locale: $locale
  ) {
    data {
      ...BrandsPageProduct
    }
    meta {
      pagination {
        page
        pageSize
        total
        pageCount
      }
    }
  }
}
    ${BrandsPageProductFragmentDoc}
${ImageFragmentDoc}`;
export const BrandsProductPageDocument = gql`
    query BrandsProductPage($locale: I18NLocaleCode) {
  brandsProductPage(locale: $locale) {
    data {
      attributes {
        tiles_title
        tiles_tile_private_label {
          title
          subtitle
          image {
            data {
              attributes {
                url
              }
            }
          }
        }
        tiles_tile_packaging {
          title
          subtitle
          image {
            ...Image
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const GetBrandsDocument = gql`
    query GetBrands($locale: I18NLocaleCode) {
  productBrands(locale: $locale, sort: "rank:asc") {
    data {
      ...Brand
    }
  }
}
    ${BrandFragmentDoc}
${BrandInfoFragmentDoc}
${ImageFragmentDoc}`;
export const GetBrandsAndProductsDocument = gql`
    query GetBrandsAndProducts($locale: I18NLocaleCode) {
  productBrands(locale: $locale, sort: "rank:asc") {
    data {
      ...BrandWithProducts
    }
  }
}
    ${BrandWithProductsFragmentDoc}
${BrandInfoFragmentDoc}
${ImageFragmentDoc}
${ProductBrandFragmentDoc}`;
export const GetBrandBySlugDocument = gql`
    query GetBrandBySlug($locale: I18NLocaleCode, $slug: String) {
  productBrands(filters: {slug: {eq: $slug}}, locale: $locale, sort: "rank:asc") {
    data {
      ...Brand
    }
  }
}
    ${BrandFragmentDoc}
${BrandInfoFragmentDoc}
${ImageFragmentDoc}`;
export const GetAllProductsDocument = gql`
    query GetAllProducts($locale: I18NLocaleCode, $start: Int, $limit: Int) {
  products(locale: $locale, pagination: {start: $start, limit: $limit}) {
    data {
      ...Product
    }
  }
}
    ${ProductFragmentDoc}
${ImageFragmentDoc}
${ProductBrandInfoFragmentDoc}
${ProductCategoriesFragmentDoc}
${ProductCutsFragmentDoc}
${ProductIngredientsFragmentDoc}
${ProductTypesFragmentDoc}
${ProductVarietiesFragmentDoc}`;
export const GetSingleBrandAndProductsDocument = gql`
    query GetSingleBrandAndProducts($locale: I18NLocaleCode, $brand_slug: String, $start: Int, $limit: Int) {
  productBrands(
    filters: {slug: {eq: $brand_slug}}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      attributes {
        ...BrandInfo
      }
    }
  }
  products(
    filters: {product_brand: {slug: {eq: $brand_slug}}}
    locale: $locale
    pagination: {start: $start, limit: $limit}
  ) {
    data {
      attributes {
        image {
          ...Image
        }
        name
        slug
        short_description
      }
    }
  }
}
    ${BrandInfoFragmentDoc}
${ImageFragmentDoc}`;
export const GetProductsByBrandSlugDocument = gql`
    query GetProductsByBrandSlug($locale: I18NLocaleCode, $brand_slug: String, $start: Int, $limit: Int) {
  products(
    filters: {product_brand: {slug: {eq: $brand_slug}}}
    locale: $locale
    pagination: {start: $start, limit: $limit}
  ) {
    data {
      ...Product
    }
  }
}
    ${ProductFragmentDoc}
${ImageFragmentDoc}
${ProductBrandInfoFragmentDoc}
${ProductCategoriesFragmentDoc}
${ProductCutsFragmentDoc}
${ProductIngredientsFragmentDoc}
${ProductTypesFragmentDoc}
${ProductVarietiesFragmentDoc}`;
export const CompanyPage1Document = gql`
    query CompanyPage1($locale: I18NLocaleCode) {
  companyPage(locale: $locale) {
    data {
      id
      attributes {
        title
        seo {
          ...seo
        }
        hero_title
        hero_introduction_title
        hero_introduction_paragraph
        certificates_certificates
        certificates_awards
        certificates_certificates_badge {
          image {
            ...Image
          }
        }
        certificates_awards_badges {
          image {
            ...Image
          }
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${ImageFragmentDoc}`;
export const CompanyPage2Document = gql`
    query CompanyPage2($locale: I18NLocaleCode) {
  companyPage(locale: $locale) {
    data {
      id
      attributes {
        title
        whoweare_title
        whoweare_largeImage {
          ...Image
        }
        Whoweare_paragraphs
        whoweare_smallImage {
          ...Image
        }
        history_title
        history_details {
          text
          year
        }
        history_video {
          data {
            attributes {
              url
            }
          }
        }
        icons_iconswithtext {
          text
          Icon {
            ...Image
          }
        }
        facilities_title
        facilities_paragraph_1
        facilities_paragraph_2
        facilities_paragraph_3
        facilities_largeImage {
          ...Image
        }
        facilities_smallImage1 {
          ...Image
        }
        facilities_smallImage2 {
          ...Image
        }
        facilities_video {
          data {
            attributes {
              url
            }
          }
        }
        environmentsocial_title
        environmentsocial_video {
          data {
            attributes {
              url
            }
          }
        }
        environmentsocial_quote
        environmentsocial_social_title
        environmentsocial_paragraph
        environmentsocial_stats {
          text
        }
        water_title
        water_description
        energy_title
        energy_description
        recycling_title
        recycling_description
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ContactPageDocument = gql`
    query contactPage($locale: I18NLocaleCode) {
  contactPage(locale: $locale) {
    data {
      id
      attributes {
        hero_title
        hero_paragraph_1
        hero_paragraph_2
        visit_title_1
        visit_paragraph_1
        visit_address
        visit_address_link
        gmaps_src
        telephones {
          text
        }
        contact_emails {
          department_name
          department_email
        }
        footer_image_1 {
          ...Image
        }
        footer_image_2 {
          ...Image
        }
        seo {
          ...seo
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${SeoFragmentDoc}`;
export const FoodServicePageDocument = gql`
    query FoodServicePage($locale: I18NLocaleCode) {
  forBusinessFoodServicePage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
        title
        hero_title
        hero_image {
          ...Image
        }
        hero_paragraph
        tile_olive_packaging {
          title
          subtitle
          image {
            ...Image
          }
        }
        tile_fruit_packaging {
          title
          subtitle
          image {
            ...Image
          }
        }
        configurator {
          title
          subtitle
          image {
            ...Image
          }
          bg_image {
            ...Image
          }
        }
      }
    }
  }
  productTypes(pagination: {page: 1, pageSize: 200}, locale: $locale) {
    data {
      attributes {
        name
        slug
        packaging_brochure {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${ImageFragmentDoc}`;
export const ForBusinessPageDocument = gql`
    query ForBusinessPage($locale: I18NLocaleCode) {
  forBusinessPage(locale: $locale) {
    data {
      id
      attributes {
        seo {
          ...seo
        }
        hero_title
        hero_description
        hero_tile_private_label {
          title
          subtitle
          image {
            ...Image
          }
        }
        hero_tile_food_service {
          title
          subtitle
          image {
            ...Image
          }
        }
        hero_tile_brands {
          title
          subtitle
          image {
            ...Image
          }
        }
        promoted_title
      }
    }
  }
  ...NewProducts
}
    ${SeoFragmentDoc}
${ImageFragmentDoc}
${NewProductsFragmentDoc}`;
export const PrivateLabelPageDocument = gql`
    query PrivateLabelPage($locale: I18NLocaleCode) {
  forBusinessPrivateLabelPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
        title
        hero_title
        hero_image {
          ...Image
        }
        hero_paragraph
        hero_paragraph_2
        process_title
        process_steps {
          image {
            ...Image
          }
          text
        }
        configurator {
          title
          subtitle
          image {
            ...Image
          }
          bg_image {
            ...Image
          }
        }
        tiles_title
        tiles_subtitle
        tiles_our_products {
          title
          subtitle
          image {
            ...Image
          }
        }
        tiles_brands {
          title
          subtitle
          image {
            ...Image
          }
        }
        process_steps {
          text
          step
          image {
            ...Image
          }
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${ImageFragmentDoc}`;
export const HomePageDocument = gql`
    query HomePage($locale: I18NLocaleCode, $limit: Int) {
  homePage(locale: $locale) {
    data {
      id
      attributes {
        seo {
          ...seo
        }
        quality_title_1
        quality_title_2
        olives_title
        olives_mini_text {
          text
        }
        olives_paragraph
        fruits_title
        fruits_mini_text {
          text
        }
        fruits_paragraph
        pl_title
        pl_paragraph
        brands_title
        enviroment_1_title
        enviroment_1_paragraph
        enviroment_mini_text {
          text
        }
        enviroment_2_title
        social_title
      }
    }
  }
  ...OliveOptions
  ...FruitOptions
  ...FeaturedProducts
}
    ${SeoFragmentDoc}
${OliveOptionsFragmentDoc}
${ImageFragmentDoc}
${FruitOptionsFragmentDoc}
${FeaturedProductsFragmentDoc}`;
export const GetProductTypesAndSubtypesDocument = gql`
    query GetProductTypesAndSubtypes($locale: I18NLocaleCode) {
  productTypes(locale: $locale, sort: "rank:asc") {
    data {
      attributes {
        slug
        name
        product_type_options(filters: {main: {eq: true}}, sort: "rank:asc") {
          data {
            attributes {
              name
              slug
            }
          }
        }
      }
    }
  }
}
    `;
export const NewsPageDocument = gql`
    query NewsPage($locale: I18NLocaleCode) {
  newsPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
        hero_title
        news_title
      }
    }
  }
  events(
    pagination: {start: 0, limit: 10}
    sort: "startDate:desc"
    locale: $locale
  ) {
    data {
      ...EventInformation
    }
  }
}
    ${SeoFragmentDoc}
${EventInformationFragmentDoc}
${ImageFragmentDoc}`;
export const BlogPostsDocument = gql`
    query BlogPosts($start: Int, $limit: Int, $locale: I18NLocaleCode) {
  blogPosts(
    pagination: {start: $start, limit: $limit}
    locale: $locale
    sort: "Date:desc"
  ) {
    data {
      ...BlogPostAttributes
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
}
    ${BlogPostAttributesFragmentDoc}`;
export const CheckIfBlogPostExistsDocument = gql`
    query CheckIfBlogPostExists($slug: String) {
  blogPosts(filters: {slug: {eq: $slug}}) {
    data {
      id
    }
  }
}
    `;
export const GetBlogPostBySlugDocument = gql`
    query GetBlogPostBySlug($slug: String) {
  blogPosts(filters: {slug: {eq: $slug}}) {
    data {
      id
      attributes {
        slug
        Title
        Date
        Text
        Image {
          ...Image
        }
        SEO {
          ...seo
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${SeoFragmentDoc}`;
export const GetEventsDocument = gql`
    query GetEvents($locale: I18NLocaleCode) {
  events(
    pagination: {start: 0, limit: 10}
    sort: "startDate:desc"
    locale: $locale
  ) {
    data {
      ...EventInformation
    }
  }
}
    ${EventInformationFragmentDoc}
${ImageFragmentDoc}`;
export const ProductsProductTypeOptionPageDocument = gql`
    query ProductsProductTypeOptionPage($locale: I18NLocaleCode) {
  productsProductTypeOptionsPage(locale: $locale) {
    data {
      attributes {
        hero_subtitle
        hero_paragraph
        cuts_title
        sizes_title
        packaging_title
        packaging_image {
          ...Image
        }
        packaging_sizes {
          title
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ProductsProductTypePackagingPageDocument = gql`
    query ProductsProductTypePackagingPage($locale: I18NLocaleCode) {
  productsProductTypePackagingPage(locale: $locale) {
    data {
      attributes {
        hero_subtitle
        hero_packaging_image {
          ...Image
        }
        hero_packaging_options {
          title
        }
      }
    }
  }
  products(pagination: {start: 0, limit: 12}, locale: $locale) {
    data {
      id
      attributes {
        name
        slug
        short_description
        image {
          ...Image
        }
        product_packagings {
          data {
            id
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const GetProductBySlugDocument = gql`
    query GetProductBySlug($slug: String, $id: ID) {
  products(filters: {slug: {eq: $slug}, id: {eq: $id}}, locale: "all") {
    data {
      ...Product
    }
  }
}
    ${ProductFragmentDoc}
${ImageFragmentDoc}
${ProductBrandInfoFragmentDoc}
${ProductCategoriesFragmentDoc}
${ProductCutsFragmentDoc}
${ProductIngredientsFragmentDoc}
${ProductTypesFragmentDoc}
${ProductVarietiesFragmentDoc}`;
export const CheckIfProductExistsDocument = gql`
    query CheckIfProductExists($slug: String, $id: ID) {
  products(filters: {slug: {eq: $slug}, id: {eq: $id}}, locale: "all") {
    data {
      id
    }
  }
}
    `;
export const GetProductVariationsDocument = gql`
    query GetProductVariations($product_type_option: String, $slug: String, $brand: String, $start: Int) {
  products(
    filters: {slug: {ne: $slug}, product_type_option: {slug: {eq: $product_type_option}}, product_brand: {slug: {eq: $brand}}}
    pagination: {start: $start, limit: 3}
  ) {
    data {
      id
      attributes {
        name
        slug
        short_description
        image {
          ...Image
        }
        product_brand {
          data {
            attributes {
              name
            }
          }
        }
        product_packagings {
          data {
            id
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const GetProductTypesDocument = gql`
    query GetProductTypes($locale: I18NLocaleCode, $start: Int, $product_type: String) {
  productTypes(locale: $locale, sort: "rank:asc") {
    data {
      ...ProductType
    }
  }
  productsPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
        hero_title
        hero_subtitle
        promoted_title
      }
    }
  }
  ...ProcessSteps
  products(
    pagination: {start: $start, limit: 12}
    locale: $locale
    filters: {product_type: {slug: {eq: $product_type}}}
  ) {
    data {
      ...Product
    }
  }
}
    ${ProductTypeFragmentDoc}
${ImageFragmentDoc}
${SeoFragmentDoc}
${ProcessStepsFragmentDoc}
${ProductFragmentDoc}
${ProductBrandInfoFragmentDoc}
${ProductCategoriesFragmentDoc}
${ProductCutsFragmentDoc}
${ProductIngredientsFragmentDoc}
${ProductTypesFragmentDoc}
${ProductVarietiesFragmentDoc}`;
export const GetCountOfProductVariationsDocument = gql`
    query GetCountOfProductVariations($product_type_option: String, $slug: String, $brand: String) {
  products(
    filters: {slug: {ne: $slug}, product_type_option: {slug: {eq: $product_type_option}}, product_brand: {slug: {eq: $brand}}}
  ) {
    meta {
      pagination {
        total
      }
    }
  }
}
    `;
export const GetRandomPrePackagedProductsDocument = gql`
    query GetRandomPrePackagedProducts($locale: I18NLocaleCode, $start: Int, $product_type: String) {
  products(
    pagination: {start: $start, limit: 12}
    locale: $locale
    filters: {product_type: {slug: {eq: $product_type}}}
  ) {
    data {
      ...Product
    }
  }
}
    ${ProductFragmentDoc}
${ImageFragmentDoc}
${ProductBrandInfoFragmentDoc}
${ProductCategoriesFragmentDoc}
${ProductCutsFragmentDoc}
${ProductIngredientsFragmentDoc}
${ProductTypesFragmentDoc}
${ProductVarietiesFragmentDoc}`;
export const GetProductTypePageDataDocument = gql`
    query GetProductTypePageData($locale: I18NLocaleCode, $product_type: String, $start: Int) {
  productTypes(
    locale: $locale
    filters: {slug: {eq: $product_type}}
    sort: "rank:asc"
  ) {
    data {
      attributes {
        slug
        name
        page_title
        hero_paragraph_1
        hero_paragraph_2
        product_type_options(filters: {main: {eq: true}}, sort: "rank:asc") {
          data {
            attributes {
              name
              slug
              icon {
                ...Image
              }
              main
            }
          }
        }
        brochure {
          data {
            attributes {
              url
            }
          }
        }
        packaging_brochure {
          data {
            attributes {
              url
            }
          }
        }
      }
    }
  }
  lozalized: productTypes(
    filters: {localizations: {slug: {eq: $product_type}}}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      id
      attributes {
        slug
        localizations {
          data {
            id
            attributes {
              locale
              slug
            }
          }
        }
      }
    }
  }
  productsProductTypePage(locale: $locale) {
    data {
      attributes {
        hero_title
        hero_subtitle
        hero_paragraph_1
        hero_paragraph_2
        cuts_title
        extras_title
        packaging_title
        packaging_image {
          ...Image
        }
        packaging_options {
          title
        }
      }
    }
  }
  products(
    pagination: {start: $start, limit: 12}
    locale: $locale
    filters: {product_type: {slug: {eq: $product_type}}}
  ) {
    data {
      ...Product
    }
  }
}
    ${ImageFragmentDoc}
${ProductFragmentDoc}
${ProductBrandInfoFragmentDoc}
${ProductCategoriesFragmentDoc}
${ProductCutsFragmentDoc}
${ProductIngredientsFragmentDoc}
${ProductTypesFragmentDoc}
${ProductVarietiesFragmentDoc}`;
export const GetProductTypeOptionsCutsDocument = gql`
    query GetProductTypeOptionsCuts($locale: I18NLocaleCode, $product_type: String) {
  productTypeOptions(
    filters: {product_type: {slug: {eq: $product_type}}}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      attributes {
        name
        product_cuts {
          data {
            attributes {
              name
              slug
              image {
                data {
                  attributes {
                    url
                    alternativeText
                    caption
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const CheckIfProductTypeExistsDocument = gql`
    query CheckIfProductTypeExists($locale: I18NLocaleCode, $slug: String) {
  productTypes(filters: {slug: {eq: $slug}}, locale: $locale) {
    data {
      id
    }
  }
}
    `;
export const CheckIfProductSubTypeExistsDocument = gql`
    query CheckIfProductSubTypeExists($slug: String) {
  productTypeOptions(filters: {slug: {eq: $slug}}, sort: "rank:asc") {
    data {
      id
    }
  }
}
    `;
export const GetProductSubTypeDataDocument = gql`
    query GetProductSubTypeData($locale: I18NLocaleCode, $product_type_option: String, $product_type: String) {
  productTypeOptions(
    locale: $locale
    filters: {slug: {eq: $product_type_option}, product_type: {slug: {eq: $product_type}}}
    sort: "rank:asc"
  ) {
    data {
      attributes {
        name
        slug
        hero_paragraph_1
        hero_paragraph_2
        product_type {
          data {
            attributes {
              slug
              page_title
              brochure {
                data {
                  attributes {
                    url
                  }
                }
              }
              packaging_brochure {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
        icon {
          ...Image
        }
        product_cuts {
          data {
            attributes {
              name
              slug
              image {
                data {
                  attributes {
                    url
                    alternativeText
                    caption
                  }
                }
              }
            }
          }
        }
        product_variations {
          data {
            id
            attributes {
              name
              product_type_options {
                data {
                  id
                  attributes {
                    slug
                    name
                  }
                }
              }
            }
          }
        }
        product_stuffings {
          data {
            id
            attributes {
              name
              product_type_options {
                data {
                  id
                  attributes {
                    slug
                    name
                  }
                }
              }
            }
          }
        }
        product_additions {
          data {
            id
            attributes {
              name
              product_type_options {
                data {
                  id
                  attributes {
                    slug
                    name
                  }
                }
              }
            }
          }
        }
        product_type_option_sizes(pagination: {start: 0, limit: 20}, sort: "width:desc") {
          data {
            id
            attributes {
              name
              slug
              size
              width
              height
              image {
                data {
                  attributes {
                    url
                    alternativeText
                    caption
                  }
                }
              }
            }
          }
        }
        subtypes {
          data {
            attributes {
              name
              slug
              icon {
                ...Image
              }
              product_cuts {
                data {
                  attributes {
                    name
                    slug
                    image {
                      data {
                        attributes {
                          url
                          alternativeText
                          caption
                        }
                      }
                    }
                  }
                }
              }
              product_stuffings {
                data {
                  id
                  attributes {
                    name
                    product_type_options {
                      data {
                        id
                        attributes {
                          slug
                          name
                        }
                      }
                    }
                  }
                }
              }
              product_additions {
                data {
                  id
                  attributes {
                    name
                    product_type_options {
                      data {
                        id
                        attributes {
                          slug
                          name
                        }
                      }
                    }
                  }
                }
              }
              product_variations {
                data {
                  id
                  attributes {
                    name
                    product_type_options {
                      data {
                        id
                        attributes {
                          slug
                          name
                        }
                      }
                    }
                  }
                }
              }
              product_type_option_sizes(pagination: {start: 0, limit: 20}, sort: "width:desc") {
                data {
                  id
                  attributes {
                    name
                    slug
                    width
                    height
                    size
                    image {
                      data {
                        attributes {
                          url
                          alternativeText
                          caption
                        }
                      }
                    }
                    product_type_options {
                      data {
                        id
                        attributes {
                          slug
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  allProductTypeOptions: productTypeOptions(
    filters: {product_type: {slug: {eq: $product_type}}, main: {eq: true}}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      attributes {
        slug
        name
        subtypes {
          data {
            id
          }
        }
        product_type {
          data {
            attributes {
              slug
            }
          }
        }
      }
    }
  }
  lozalizedSubType: productTypeOptions(
    filters: {localizations: {slug: {eq: $product_type_option}}}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      id
      attributes {
        slug
        localizations {
          data {
            id
            attributes {
              locale
              slug
            }
          }
        }
      }
    }
  }
  lozalizedType: productTypes(
    filters: {localizations: {slug: {eq: $product_type}}}
    locale: $locale
    sort: "rank:asc"
  ) {
    data {
      id
      attributes {
        slug
        localizations {
          data {
            id
            attributes {
              locale
              slug
            }
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ProductSizesDocument = gql`
    query ProductSizes($locale: I18NLocaleCode) {
  productSizes(
    pagination: {page: 1, pageSize: 200}
    filters: {product_sizes_container: {id: {notNull: true}}}
    locale: $locale
  ) {
    data {
      id
      attributes {
        name
        rank
        parent {
          data {
            id
          }
        }
      }
      attributes {
        product_sizes_container {
          data {
            id
            attributes {
              name
              rank
            }
          }
        }
      }
    }
  }
  parents: productSizes(
    pagination: {page: 1, pageSize: 200}
    filters: {parent: {id: {null: true}}}
    locale: $locale
  ) {
    ...psp
  }
  productTypes(pagination: {page: 1, pageSize: 200}, locale: $locale) {
    data {
      attributes {
        name
        slug
        packaging_brochure {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
      }
    }
  }
}
    ${PspFragmentDoc}
${PsFragmentDoc}`;
export const ProductSizesBySlugDocument = gql`
    query ProductSizesBySlug($locale: I18NLocaleCode, $product_slug: String, $product_id: ID) {
  productSizes(
    pagination: {page: 1, pageSize: 200}
    filters: {product_sizes_container: {id: {notNull: true}}, products: {slug: {eq: $product_slug}, id: {eq: $product_id}}}
    locale: $locale
  ) {
    data {
      id
      attributes {
        name
        rank
        parent {
          data {
            id
          }
        }
      }
      attributes {
        product_sizes_container {
          data {
            id
            attributes {
              name
              rank
            }
          }
        }
      }
    }
  }
  parents: productSizes(
    pagination: {page: 1, pageSize: 200}
    filters: {parent: {id: {null: true}}}
    locale: $locale
  ) {
    ...psp
  }
}
    ${PspFragmentDoc}
${PsFragmentDoc}`;
export const NewsTitleDocument = gql`
    query newsTitle($locale: I18NLocaleCode) {
  newsPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const BrandsTitleDocument = gql`
    query brandsTitle($locale: I18NLocaleCode) {
  brandsPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const ProductsTitleDocument = gql`
    query productsTitle($locale: I18NLocaleCode) {
  productsPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const ContactTitleDocument = gql`
    query contactTitle($locale: I18NLocaleCode) {
  contactPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const ForBusinessTitleDocument = gql`
    query forBusinessTitle($locale: I18NLocaleCode) {
  forBusinessPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const PrivateLabelTitleDocument = gql`
    query PrivateLabelTitle($locale: I18NLocaleCode) {
  forBusinessPrivateLabelPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const FoodServiceTitleDocument = gql`
    query FoodServiceTitle($locale: I18NLocaleCode) {
  forBusinessFoodServicePage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const HomeTitleDocument = gql`
    query homeTitle($locale: I18NLocaleCode) {
  homePage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const CompanyTitleDocument = gql`
    query companyTitle($locale: I18NLocaleCode) {
  companyPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...seo
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    BrandedProductSizes(variables?: BrandedProductSizesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandedProductSizesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandedProductSizesQuery>(BrandedProductSizesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BrandedProductSizes', 'query');
    },
    BrandsPage(variables?: BrandsPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandsPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandsPageQuery>(BrandsPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BrandsPage', 'query');
    },
    BrandsPageProducts(variables?: BrandsPageProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandsPageProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandsPageProductsQuery>(BrandsPageProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BrandsPageProducts', 'query');
    },
    BrandsProductPage(variables?: BrandsProductPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandsProductPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandsProductPageQuery>(BrandsProductPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BrandsProductPage', 'query');
    },
    GetBrands(variables?: GetBrandsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBrandsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBrandsQuery>(GetBrandsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBrands', 'query');
    },
    GetBrandsAndProducts(variables?: GetBrandsAndProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBrandsAndProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBrandsAndProductsQuery>(GetBrandsAndProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBrandsAndProducts', 'query');
    },
    GetBrandBySlug(variables?: GetBrandBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBrandBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBrandBySlugQuery>(GetBrandBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBrandBySlug', 'query');
    },
    GetAllProducts(variables?: GetAllProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllProductsQuery>(GetAllProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAllProducts', 'query');
    },
    GetSingleBrandAndProducts(variables?: GetSingleBrandAndProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSingleBrandAndProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSingleBrandAndProductsQuery>(GetSingleBrandAndProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSingleBrandAndProducts', 'query');
    },
    GetProductsByBrandSlug(variables?: GetProductsByBrandSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductsByBrandSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductsByBrandSlugQuery>(GetProductsByBrandSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductsByBrandSlug', 'query');
    },
    CompanyPage1(variables?: CompanyPage1QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyPage1Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyPage1Query>(CompanyPage1Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyPage1', 'query');
    },
    CompanyPage2(variables?: CompanyPage2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyPage2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyPage2Query>(CompanyPage2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyPage2', 'query');
    },
    contactPage(variables?: ContactPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactPageQuery>(ContactPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactPage', 'query');
    },
    FoodServicePage(variables?: FoodServicePageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FoodServicePageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FoodServicePageQuery>(FoodServicePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FoodServicePage', 'query');
    },
    ForBusinessPage(variables?: ForBusinessPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForBusinessPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForBusinessPageQuery>(ForBusinessPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ForBusinessPage', 'query');
    },
    PrivateLabelPage(variables?: PrivateLabelPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateLabelPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateLabelPageQuery>(PrivateLabelPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateLabelPage', 'query');
    },
    HomePage(variables?: HomePageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HomePageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomePageQuery>(HomePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HomePage', 'query');
    },
    GetProductTypesAndSubtypes(variables?: GetProductTypesAndSubtypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductTypesAndSubtypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductTypesAndSubtypesQuery>(GetProductTypesAndSubtypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductTypesAndSubtypes', 'query');
    },
    NewsPage(variables?: NewsPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewsPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewsPageQuery>(NewsPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewsPage', 'query');
    },
    BlogPosts(variables?: BlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsQuery>(BlogPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPosts', 'query');
    },
    CheckIfBlogPostExists(variables?: CheckIfBlogPostExistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckIfBlogPostExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckIfBlogPostExistsQuery>(CheckIfBlogPostExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckIfBlogPostExists', 'query');
    },
    GetBlogPostBySlug(variables?: GetBlogPostBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBlogPostBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostBySlugQuery>(GetBlogPostBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBlogPostBySlug', 'query');
    },
    GetEvents(variables?: GetEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEventsQuery>(GetEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEvents', 'query');
    },
    ProductsProductTypeOptionPage(variables?: ProductsProductTypeOptionPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsProductTypeOptionPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsProductTypeOptionPageQuery>(ProductsProductTypeOptionPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductsProductTypeOptionPage', 'query');
    },
    ProductsProductTypePackagingPage(variables?: ProductsProductTypePackagingPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsProductTypePackagingPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsProductTypePackagingPageQuery>(ProductsProductTypePackagingPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductsProductTypePackagingPage', 'query');
    },
    GetProductBySlug(variables?: GetProductBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductBySlugQuery>(GetProductBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductBySlug', 'query');
    },
    CheckIfProductExists(variables?: CheckIfProductExistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckIfProductExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckIfProductExistsQuery>(CheckIfProductExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckIfProductExists', 'query');
    },
    GetProductVariations(variables?: GetProductVariationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductVariationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductVariationsQuery>(GetProductVariationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductVariations', 'query');
    },
    GetProductTypes(variables?: GetProductTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductTypesQuery>(GetProductTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductTypes', 'query');
    },
    GetCountOfProductVariations(variables?: GetCountOfProductVariationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCountOfProductVariationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCountOfProductVariationsQuery>(GetCountOfProductVariationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCountOfProductVariations', 'query');
    },
    GetRandomPrePackagedProducts(variables?: GetRandomPrePackagedProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRandomPrePackagedProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRandomPrePackagedProductsQuery>(GetRandomPrePackagedProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetRandomPrePackagedProducts', 'query');
    },
    GetProductTypePageData(variables?: GetProductTypePageDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductTypePageDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductTypePageDataQuery>(GetProductTypePageDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductTypePageData', 'query');
    },
    GetProductTypeOptionsCuts(variables?: GetProductTypeOptionsCutsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductTypeOptionsCutsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductTypeOptionsCutsQuery>(GetProductTypeOptionsCutsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductTypeOptionsCuts', 'query');
    },
    CheckIfProductTypeExists(variables?: CheckIfProductTypeExistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckIfProductTypeExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckIfProductTypeExistsQuery>(CheckIfProductTypeExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckIfProductTypeExists', 'query');
    },
    CheckIfProductSubTypeExists(variables?: CheckIfProductSubTypeExistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckIfProductSubTypeExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckIfProductSubTypeExistsQuery>(CheckIfProductSubTypeExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckIfProductSubTypeExists', 'query');
    },
    GetProductSubTypeData(variables?: GetProductSubTypeDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductSubTypeDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductSubTypeDataQuery>(GetProductSubTypeDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductSubTypeData', 'query');
    },
    ProductSizes(variables?: ProductSizesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductSizesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductSizesQuery>(ProductSizesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductSizes', 'query');
    },
    ProductSizesBySlug(variables?: ProductSizesBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductSizesBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductSizesBySlugQuery>(ProductSizesBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductSizesBySlug', 'query');
    },
    newsTitle(variables?: NewsTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewsTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewsTitleQuery>(NewsTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'newsTitle', 'query');
    },
    brandsTitle(variables?: BrandsTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandsTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandsTitleQuery>(BrandsTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandsTitle', 'query');
    },
    productsTitle(variables?: ProductsTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsTitleQuery>(ProductsTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsTitle', 'query');
    },
    contactTitle(variables?: ContactTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactTitleQuery>(ContactTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactTitle', 'query');
    },
    forBusinessTitle(variables?: ForBusinessTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForBusinessTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForBusinessTitleQuery>(ForBusinessTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forBusinessTitle', 'query');
    },
    PrivateLabelTitle(variables?: PrivateLabelTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateLabelTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateLabelTitleQuery>(PrivateLabelTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateLabelTitle', 'query');
    },
    FoodServiceTitle(variables?: FoodServiceTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FoodServiceTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FoodServiceTitleQuery>(FoodServiceTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FoodServiceTitle', 'query');
    },
    homeTitle(variables?: HomeTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HomeTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomeTitleQuery>(HomeTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'homeTitle', 'query');
    },
    companyTitle(variables?: CompanyTitleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyTitleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyTitleQuery>(CompanyTitleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyTitle', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;